import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import Txt from '../atoms/Txt';
import ImgFit from '../atoms/ImgFit';
import Col from '../atoms/FlexColumn';
import Row from '../atoms/FlexRow';
import { readFile } from '../../utils/loadImg';
import { uploadPhotoURl } from '../../database/utils/storage';
import { updateSelfUser } from '../../database/repositories/UserRepository';

const Body = styled.div`
  border: 3px solid #7e7d7a;
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  width: 25%;
  height: 60%;
  border-radius: 15px;

  @media (max-width: 768px) {
    display: none;
  }

  ul {
    list-style: none;
  }

  i {
    margin: 8px 8px;
    font-size: 40px;

    @media (max-width: 768px) {
      font-size: 23px;
      margin: 1px 6px;
    }
  }

  a:hover {
    text-decoration: none;
  }

  #input[type='file'] {
    display: none;
  }
  .label {
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: larger;
    margin-bottom: 10px;
  }
  .image-upload {
    margin: auto;
    width: 200px;
    height: 50px;
    color: white;
    border-radius: 10px;
    background-color: red;
    text-align: center;
    padding-top: 10px;
    cursor: pointer;
  }
`;

const PhotoWrapper = styled.div`
  border-radius: 50%;
  border: 6px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
  margin-bottom: 10px;
  img {
    width: 240px;
    height: 240px;
    border-radius: 50%;
    @media (max-width: 768px) {
      width: 120px;
      height: 120px;
    }
  }
`;

function ProfileCardMenu() {
  const [img, setImg] = useState(
    'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png'
  );

  const userID = useSelector((state) => state.auth.uid);
  const userData = useSelector((state) => state.auth.user_data);
  const profilePhotoUrl = useSelector((state) => state.auth.user_photo_url);

  const changeImage = async (e) => {
    const { file, dataURL } = await readFile(e.target.files[0]);
    uploadPhotoURl(userID, file.name, dataURL).then(() =>
      updateSelfUser({
        photo: `prof_img_${file.name}`
      })
    );
  };

  useEffect(() => {
    setImg(profilePhotoUrl);
  }, [profilePhotoUrl]);

  return (
    <Body>
      <PhotoWrapper>
        <ImgFit id="signup_photo_img" src={img} />
      </PhotoWrapper>
      <input type="file" accept="image/*" name="image-upload" id="input" onChange={changeImage} />
      <div className="label" style={{ width: '130px', alignSelf: 'center' }}>
        <label className="image-upload" htmlFor="input">
          Alterar foto
        </label>
      </div>
      <Col>
        <Txt bold size={22}>
          {userData?.name}
        </Txt>
        <Txt bold size={12}>
          KAKARECANDO DESDE{' '}
          {userData ? new Date(userData.joinDate).toLocaleDateString('pt-br') : null}
        </Txt>
      </Col>
      <Col align="flex-start" padding="30px">
        <Row>
          <i className="fas fa-cash-register" />
          <Txt size={18} href="/usuario/vendas/abertas">
            MINHAS VENDAS
          </Txt>
        </Row>
        <Col align="flex-start" margin="0 0 0 60px">
          <Txt href="/usuario/vitrine">NA VITRINE</Txt>
          <Txt href="/usuario/vendas/concluidas">VENDIDOS</Txt>
        </Col>
        <Row>
          <i className="fas fa-shopping-basket" />
          <Txt size={18} href="/usuario/compras/abertas">
            MINHAS COMPRAS
          </Txt>
        </Row>
        <Row>
          <i className="far fa-heart" />
          <Txt size={18} href="/usuario/favoritos">
            MEUS FAVORITOS
          </Txt>
        </Row>
        <Row>
          <i className="far fa-credit-card" />
          <Txt size={18} href="/usuario/pagamentos">
            PAGAMENTOS
          </Txt>
        </Row>
        <Row>
          <i className="fas fa-cogs" />
          <Txt size={18} href="/usuario/configuracoes/meusdados">
            CONFIGURAÇÃO
          </Txt>
        </Row>
        <Col align="flex-start" margin="0 0 0 60px">
          <Txt href="/usuario/configuracoes/meusdados">MEUS DADOS</Txt>
          <Txt href="/usuario/configuracoes/emails">E-MAIL</Txt>
          <Txt href="/usuario/configuracoes/seguranca">SEGURANÇA</Txt>
          <Txt href="/admin">Admin</Txt>
        </Col>
      </Col>
    </Body>
  );
}

export default ProfileCardMenu;
